import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";

export enum VerificationServiceDetailsActionTypes {
    SET_VERIFICATION_SERVICE_DETAILS_LOADING = "SET_VERIFICATION_SERVICE_DETAILS_LOADING",
    SET_VERIFICATION_SERVICE_DETAILS = "SET_VERIFICATION_SERVICE_DETAILS"
}

// Data
type SetVerificationServiceDetailsLoadingAction = {
    type: VerificationServiceDetailsActionTypes.SET_VERIFICATION_SERVICE_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setVerificationServiceDetailsLoading = (isLoading: boolean): SetVerificationServiceDetailsLoadingAction => ({
    type: VerificationServiceDetailsActionTypes.SET_VERIFICATION_SERVICE_DETAILS_LOADING,
    payload: { isLoading }
});

type SetVerificationServiceDetailsAction = {
    type: VerificationServiceDetailsActionTypes.SET_VERIFICATION_SERVICE_DETAILS,
    payload: { verificationServiceDetails: FormattedRpServiceConfiguration; }
}

export const setVerificationServiceDetails = (verificationServiceDetails: FormattedRpServiceConfiguration): SetVerificationServiceDetailsAction => ({
    type: VerificationServiceDetailsActionTypes.SET_VERIFICATION_SERVICE_DETAILS,
    payload: { verificationServiceDetails }
});

export type VerificationServiceDetailsActions =
    SetVerificationServiceDetailsLoadingAction |
    SetVerificationServiceDetailsAction